<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">脱单圈审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>发布状态：</label>
          <el-select v-model="anonymity" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in anonymityArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>优质状态：</label>
          <el-select v-model="qualityState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in qualityStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
<!--          <el-button type="primary" @click="editReleaseDialog(-1)">新建脱单全</el-button>-->
          <el-button type="success" @click="batchUpdate(2)" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(3)" v-loading="bitchRejectLoading">批量不通过</el-button>
          <el-button type="success" @click="setQualityState(1)" v-loading="bitchSetLoading">设为优质</el-button>
          <el-button type="danger"  @click="setQualityState(2)" v-loading="bitchUnsetLoading">取消优质</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="发布时间" v-if="checkColList.indexOf('发布时间') > -1"/>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="224">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid"/>
            </template>
          </el-table-column>
          <el-table-column property="content" label="脱单圈内容" v-if="checkColList.indexOf('脱单圈内容') > -1" min-width="160"/>
          <el-table-column prop="" label="图片" v-if="checkColList.indexOf('图片') > -1" width="200">
            <template #default="scope">
              <el-space wrap>
                <el-image style="width: 48px; height: 48px" fit="cover" v-for="(item, index) in scope.row.cdtctdCoilImgList" :key="item.id" :src="item.smallImg" @click="showImg(index, scope.row.cdtctdCoilImgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="" label="捐赠金额" v-if="checkColList.indexOf('捐赠金额') > -1" >
            <template #default="scope">
              <p>{{ scope.row.donationAmount }}元</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="发布状态" v-if="checkColList.indexOf('发布状态') > -1">
            <template #default="scope">
              <p>{{ scope.row.anonymity == 0 ? '公开' : scope.row.anonymity == 1 ? '匿名' : '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{ scope.row.state == 1 ? '待审核' : scope.row.state == 2 ? '已通过' : scope.row.state == 3 ? '不通过' : '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="优质状态" width="180">
            <template #default="scope">
              <p v-if="scope.row.qualityState == 0">未设为优质</p>
              <p v-if="scope.row.qualityState == 1"><span style="color: #5daf34">已设为优质</span></p>
              <p v-if="scope.row.qualityState == 2"><span style="color: #ff5e5e">已取消优质</span></p>
              <div style="padding-top: 6px;" v-show="scope.row.qualityState == 1 || scope.row.qualityState == 2">
                <p>首次设为优质</p>
                {{ scope.row.qualityTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getSingleReviewPageList, updateSingleQualityState, updateSingleState
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import ImgUpload from "@/views/single/components/release/ImgUpload";
import ReleaseDialog from "@/views/single/components/release/ReleaseDialog";

export default {
  name: "SingleRelease",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 1},
        {label: '审核通过', value: 2},
        {label: '审核不通过', value: 3},
      ],
      state: 1,

      // 发布状态
      anonymityArray: [
        {label: '不限', value: -1},
        {label: '匿名', value: 1},
        {label: '公开', value: 0}
      ],
      anonymity: -1,

      // 优质状态
      qualityStateArray: [
        {label: '不限', value: -1},
        {label: '未设为优质', value: 0},
        {label: '已设为优质', value: 1},
        {label: '已取消优质', value: 2}
      ],
      qualityState: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['发布时间', '用户信息', '脱单圈内容', '图片', '捐赠金额', '发布状态', '状态', '优质状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchSetLoading: false,
      bitchUnsetLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // getExpireTime(val) {
    //   this.startExpire = val[0];
    //   this.endExpire = val[1];
    //   // console.log(val)
    // },
    //
    // getExpireCheck(val) {
    //   this.isExpireChecked = val
    // },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = 1;
      this.anonymity = -1;
      this.qualityState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['qualityState'] = this.qualityState;
      param['anonymity'] = this.anonymity;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSingleReviewPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '头像') {
        Dialog.open({
          title: '上传头像图片',
          component: ImgUpload,
          data: {
            id: row.officialId,
            src: row.portrait,
            width: '400px'
          },
          close: () => {
            this.getPage()
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    updateState(state, row, idx) {
      this.$confirm('确认把' + row.nickName + '的脱单圈' + (state == 2?'【上架】':'【下架】') ).then(()=>{
        row.updateLoading = true
        let _this = this;
        let arr = [];
        arr.push(row.id)
        let param = {};
        param['idArr'] = arr
        param['state'] = state
        postFormData(updateSingleState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.state = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row.updateLoading = false;
        })
            .catch(()=>{
              row.updateLoading = false;
            })
      })
    },

    setQualityState(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 1?'【设置优质】':'【取消优质】') +'选中脱单圈').then(()=>{
          if(state == 1) {
            this.bitchSetLoading = true;
          }else {
            this.bitchUnsetLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray
          param['qualityState'] = state
          postFormData(updateSingleQualityState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              _this.getPage();
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchSetLoading = false;
            _this.bitchUnsetLoading = false;
          })
              .catch(()=>{
                _this.bitchSetLoading = false;
                _this.bitchUnsetLoading = false;
              })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中脱单圈').then(()=>{
          if(state == 1) {
            this.bitchPassLoading = true;
          }else {
            this.bitchRejectLoading = true;
          }
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray
          param['state'] = state
          postFormData(updateSingleState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.bitchPassLoading = false;
            _this.bitchRejectLoading = false;
          })
              .catch(()=>{
                _this.bitchPassLoading = false;
                _this.bitchRejectLoading = false;
              })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },



    editReleaseDialog(idx, row) {
      let _title = '';
      let releaseForm = {province: '广东', city: '广州'};
      if (idx > -1) {
        _title = '新建'
        releaseForm = Object.assign({}, row);
      }else {
        _title = '编辑'
      }
      Dialog.open({
        title: _title,
        component: ReleaseDialog,
        data: {
          releaseForm: releaseForm,
          ids: idx,
        },
        confirm: (result) => {
          this.getPage()
        },
        close: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
